import React from 'react';

import PropTypes from 'prop-types';

import { Text } from 'apps/auth/components/common/Text/Text';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';

const ActivityAmount = ({ item = {}, options, baseColor = 'primary', useArrow = false, isFrom = true }) => {
    const { failedCheque = false } = options;
    const { country } = useApp();
    const { lang } = useLanguage();

    return (
        <>
            <Text size="header" color={failedCheque ? 'lightGray' : baseColor} ellipsis lineThrough={failedCheque}>
                {`${getLocalizedRawAmount(lang, country, isFrom ? item.frAmtReal : item.toAmtReal)} `}
                <Text size="header" smallCaps color={failedCheque ? 'lightGray' : baseColor}>
                    {isFrom ? item.mobileInfo.frCurIso : item.mobileInfo.toCurIso}
                </Text>
            </Text>
            {useArrow && (
                <Text size="header" color={failedCheque ? 'lightGray' : baseColor}>
                    {' → '}
                </Text>
            )}
        </>
    );
};
ActivityAmount.propTypes = {
    useArrow: PropTypes.bool,
    isFrom: PropTypes.bool,
    baseColor: PropTypes.string,
    item: PropTypes.object,
    options: PropTypes.object,
};
export default ActivityAmount;
